import { ContentState, convertToRaw } from 'draft-js';
import { WidgetType } from '@common/api';
import { LabelOptions, SubtotalsOptions, TagNameDisplay, } from '@data/types';
import { Chart, FormatType, KpiColumnOperation, NumberFormatType, NumFmt, Period } from '@util/enums';
export function parseWidgetConfig(config, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50;
    var widgetConfigParsed = {};
    if (config !== null && config !== undefined && config !== '') {
        try {
            widgetConfigParsed = JSON.parse(config);
        }
        catch (err) {
            widgetConfigParsed = {};
        }
    }
    // map by type
    switch (type) {
        case WidgetType.KPI: {
            var c = {
                path: (_a = widgetConfigParsed['path']) !== null && _a !== void 0 ? _a : '0',
                showZeroSumRows: !!widgetConfigParsed['showZeroSumRows'],
                kpiCols: (_b = widgetConfigParsed['kpiCols']) !== null && _b !== void 0 ? _b : [],
                uncollapsed: (_c = widgetConfigParsed['uncollapsed']) !== null && _c !== void 0 ? _c : [],
                exportConfigurationId: (_d = widgetConfigParsed['exportConfigurationId']) !== null && _d !== void 0 ? _d : 0,
                sharedColumnConfigWidgetId: (_e = widgetConfigParsed['sharedColumnConfigWidgetId']) !== null && _e !== void 0 ? _e : null,
                colWidth: (_f = widgetConfigParsed['colWidth']) !== null && _f !== void 0 ? _f : [],
                sort: (_g = widgetConfigParsed['sort']) !== null && _g !== void 0 ? _g : null,
                useSlicerData: !!widgetConfigParsed['useSlicerData'],
                useTagSlicers: !!widgetConfigParsed['useTagSlicers'],
                numformat: (_h = widgetConfigParsed['numformat']) !== null && _h !== void 0 ? _h : NumberFormatType.FORMATTED,
                rowNameDisplay: (_j = widgetConfigParsed['rowNameDisplay']) !== null && _j !== void 0 ? _j : TagNameDisplay.Both,
            };
            return c;
        }
        case WidgetType.CHART: {
            var c = {
                lines: (_k = widgetConfigParsed['lines']) !== null && _k !== void 0 ? _k : [],
                xAxisTagIds: (_l = widgetConfigParsed['xAxisTagIds']) !== null && _l !== void 0 ? _l : [[]],
                hideAxis: !!widgetConfigParsed['hideAxis'],
                showLabels: !!widgetConfigParsed['showLabels'],
                labels: {
                    type: (_o = (_m = widgetConfigParsed['labels']) === null || _m === void 0 ? void 0 : _m['type']) !== null && _o !== void 0 ? _o : FormatType.PERCENTAGE,
                    numFmt: (_q = (_p = widgetConfigParsed['labels']) === null || _p === void 0 ? void 0 : _p['numFmt']) !== null && _q !== void 0 ? _q : NumFmt.TWO_DECIMALS,
                },
                chartType: (_r = widgetConfigParsed['chartType']) !== null && _r !== void 0 ? _r : Chart.COMBINED,
                chartHorizontal: !!widgetConfigParsed['chartHorizontal'],
                useTagSlicers: !!widgetConfigParsed['useTagSlicers'],
            };
            return c;
        }
        case WidgetType.VARIABLE: {
            var c = {};
            return c;
        }
        case WidgetType.TREECHANGE: {
            var c = {};
            return c;
        }
        case WidgetType.SINGLEVALUE: {
            var c = {
                numformat: (_s = widgetConfigParsed['numformat']) !== null && _s !== void 0 ? _s : NumberFormatType.FORMATTED,
                accountTags: (_t = widgetConfigParsed['accountTags']) !== null && _t !== void 0 ? _t : [],
                filterTags: (_u = widgetConfigParsed['filterTags']) !== null && _u !== void 0 ? _u : [],
                comparisonTags: (_v = widgetConfigParsed['comparisonTags']) !== null && _v !== void 0 ? _v : [],
                useTagSlicers: (_w = widgetConfigParsed['useTagSlicers']) !== null && _w !== void 0 ? _w : false,
                dataEntry: (_x = widgetConfigParsed['dataEntry']) !== null && _x !== void 0 ? _x : false,
                showDataEntryButtons: (_y = widgetConfigParsed['showDataEntryButtons']) !== null && _y !== void 0 ? _y : false,
                dataEntryButtonStep: (_z = widgetConfigParsed['dataEntryButtonStep']) !== null && _z !== void 0 ? _z : '10%',
                comparisonCustomText: (_0 = widgetConfigParsed['comparisonCustomText']) !== null && _0 !== void 0 ? _0 : '',
            };
            return c;
        }
        case WidgetType.SIMULATION: {
            var c = {
                dataEditorCols: (_1 = widgetConfigParsed['dataEditorCols']) !== null && _1 !== void 0 ? _1 : [{ label: 'Col', tagIds: [] }],
                dataEditorRows: (_2 = widgetConfigParsed['dataEditorRows']) !== null && _2 !== void 0 ? _2 : [],
                dataEditorFontSize: (_3 = widgetConfigParsed['dataEditorFontSize']) !== null && _3 !== void 0 ? _3 : 15,
                dataEditorValues: (_4 = widgetConfigParsed['dataEditorValues']) !== null && _4 !== void 0 ? _4 : {},
                dataEditorCellSizes: {
                    widths: (_6 = (_5 = widgetConfigParsed['dataEditorCellSizes']) === null || _5 === void 0 ? void 0 : _5['widths']) !== null && _6 !== void 0 ? _6 : [150],
                    heights: (_8 = (_7 = widgetConfigParsed['dataEditorCellSizes']) === null || _7 === void 0 ? void 0 : _7['heights']) !== null && _8 !== void 0 ? _8 : [],
                },
                dataEditorBtnControls: {
                    active: (_10 = (_9 = widgetConfigParsed['dataEditorBtnControls']) === null || _9 === void 0 ? void 0 : _9['active']) !== null && _10 !== void 0 ? _10 : false,
                    step: (_12 = (_11 = widgetConfigParsed['dataEditorBtnControls']) === null || _11 === void 0 ? void 0 : _11['step']) !== null && _12 !== void 0 ? _12 : 1,
                },
            };
            return c;
        }
        case WidgetType.SLICER: {
            var c = {
                intervalStart: (_13 = widgetConfigParsed['intervalStart']) !== null && _13 !== void 0 ? _13 : "01/".concat(new Date().getFullYear()),
                intervalEnd: (_14 = widgetConfigParsed['intervalEnd']) !== null && _14 !== void 0 ? _14 : "12/".concat(new Date().getFullYear()),
                periods: (_15 = widgetConfigParsed['periods']) !== null && _15 !== void 0 ? _15 : [Period.MONTH],
                showSum: !!widgetConfigParsed['showSum'],
                comparisonOperation: (_16 = widgetConfigParsed['comparisonOperation']) !== null && _16 !== void 0 ? _16 : KpiColumnOperation.DIFF_PERCENT,
                yearVersions: (_17 = widgetConfigParsed['yearVersions']) !== null && _17 !== void 0 ? _17 : {},
                yearVersionComparisons: (_18 = widgetConfigParsed['yearVersionComparisons']) !== null && _18 !== void 0 ? _18 : [],
                numformat: (_19 = widgetConfigParsed['numformat']) !== null && _19 !== void 0 ? _19 : NumberFormatType.FORMATTED,
            };
            return c;
        }
        case WidgetType.TAGSLICER: {
            var c = {
                tags: (_20 = widgetConfigParsed['tags']) !== null && _20 !== void 0 ? _20 : [],
                multipleSelect: !!widgetConfigParsed['multipleSelect'],
                tagSlicerTags: (_21 = widgetConfigParsed['tagSlicerTags']) !== null && _21 !== void 0 ? _21 : [],
                tagSlicerFilterTagIds: (_22 = widgetConfigParsed['tagSlicerFilterTagIds']) !== null && _22 !== void 0 ? _22 : [],
                onlyWithDataAccountId: (_23 = widgetConfigParsed['onlyWithDataAccountId']) !== null && _23 !== void 0 ? _23 : null,
                onlyWithDataDimensionIds: (_24 = widgetConfigParsed['onlyWithDataDimensionIds']) !== null && _24 !== void 0 ? _24 : [],
                tagNameDisplay: (_25 = widgetConfigParsed['tagNameDisplay']) !== null && _25 !== void 0 ? _25 : TagNameDisplay.Both,
            };
            return c;
        }
        case WidgetType.DATAEDITOR: {
            var c = {
                dataEditorCols: (_26 = widgetConfigParsed['dataEditorCols']) !== null && _26 !== void 0 ? _26 : [{ label: 'Col', tagIds: [] }],
                dataEditorRows: (_27 = widgetConfigParsed['dataEditorRows']) !== null && _27 !== void 0 ? _27 : [],
                dataEditorFontSize: (_28 = widgetConfigParsed['dataEditorFontSize']) !== null && _28 !== void 0 ? _28 : 15,
                dataEditorValues: (_29 = widgetConfigParsed['dataEditorValues']) !== null && _29 !== void 0 ? _29 : {},
                dataEditorCellSizes: {
                    widths: (_31 = (_30 = widgetConfigParsed['dataEditorCellSizes']) === null || _30 === void 0 ? void 0 : _30['widths']) !== null && _31 !== void 0 ? _31 : [],
                    heights: (_33 = (_32 = widgetConfigParsed['dataEditorCellSizes']) === null || _32 === void 0 ? void 0 : _32['heights']) !== null && _33 !== void 0 ? _33 : [],
                },
                dataEditorBtnControls: {
                    active: (_35 = (_34 = widgetConfigParsed['dataEditorBtnControls']) === null || _34 === void 0 ? void 0 : _34['active']) !== null && _35 !== void 0 ? _35 : false,
                    step: (_37 = (_36 = widgetConfigParsed['dataEditorBtnControls']) === null || _36 === void 0 ? void 0 : _36['step']) !== null && _37 !== void 0 ? _37 : 1,
                },
            };
            return c;
        }
        case WidgetType.TEXTTILE: {
            var c = {
                editorRawContent: (_38 = widgetConfigParsed['editorRawContent']) !== null && _38 !== void 0 ? _38 : convertToRaw(ContentState.createFromText('Double click to start typing...')),
            };
            return c;
        }
        case WidgetType.PIVOT: {
            var c = {
                filters: (_39 = widgetConfigParsed['filters']) !== null && _39 !== void 0 ? _39 : [],
                columns: (_40 = widgetConfigParsed['columns']) !== null && _40 !== void 0 ? _40 : [[]],
                rows: (_41 = widgetConfigParsed['rows']) !== null && _41 !== void 0 ? _41 : [[]],
                variables: (_42 = widgetConfigParsed['variables']) !== null && _42 !== void 0 ? _42 : [[[]]],
                subtotals: (_43 = widgetConfigParsed['subtotals']) !== null && _43 !== void 0 ? _43 : SubtotalsOptions.DISABLED,
                labels: (_44 = widgetConfigParsed['labels']) !== null && _44 !== void 0 ? _44 : LabelOptions.NAME_DESCRIPTION,
                expandedPaths: (_45 = widgetConfigParsed['expandedPaths']) !== null && _45 !== void 0 ? _45 : [],
                columnWidths: (_46 = widgetConfigParsed['columnWidths']) !== null && _46 !== void 0 ? _46 : [],
                globalFormat: (_47 = widgetConfigParsed['globalFormat']) !== null && _47 !== void 0 ? _47 : NumberFormatType.TWO_DECIMALS,
                hideGridlines: (_48 = widgetConfigParsed['hideGridlines']) !== null && _48 !== void 0 ? _48 : false,
                freezeRowsColumns: (_49 = widgetConfigParsed['freezeRowsColumns']) !== null && _49 !== void 0 ? _49 : true,
                hideRowColumnHeaders: (_50 = widgetConfigParsed['hideRowColumnHeaders']) !== null && _50 !== void 0 ? _50 : false,
            };
            return c;
        }
        default: {
            return widgetConfigParsed;
        }
    }
}
